(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["once-pill-link"] && !Shopify.designMode) return;
  try {
    // Shows the pill once the top of its section is well into the screen, and
  // hides it again when the visitor scrolls back up above the section.
  class OncePillLink extends HTMLElement {
    connectedCallback() {
      const section = this.parentElement;
      if (!section || !('IntersectionObserver' in window)) {
        this.toggleAttribute('data-shown', true);
        return;
      }
      this.observer = new IntersectionObserver(
        ([entry]) => this.toggleAttribute('data-shown', entry.isIntersecting),
        // Counts as "in" once the section reaches 35% up from the bottom.
        { rootMargin: '0px 0px -35% 0px' }
      );
      this.observer.observe(section);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('once-pill-link')) {
    customElements.define('once-pill-link', OncePillLink);
  }
  } catch(e) { console.error(e); }
})();

})();
